import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProgressBar } from "../../Other/ProgressBar/ProgressBar";
import OverlayContainer from "../../Overlay/OverlayContainer";
import axiosInstance from "../../../axios";
import ChapterDocument from "./CourseChapterDetails/chapterDocument";
import { getS3URL } from "../../../_helpers";
import Button from "../../Other/element/Button";
import { duration } from "moment";

const CoursePercentage = ({ course }) => {
  const { t } = useTranslation();
  const [courseprogress, setCourseProgress] = useState(0);
  const [printCertificate, setPrintCertificate] = useState(false);
  const [certifcateDetails, setCertificateDetails] = useState();
  const [response, setResponse] = useState();

  const chapterPercentageCalculation = (listOfChapters) => {
    let totalTragetDuration = 0;
    let tillNowCompletedDuration = 0;
    let chapterPercentageRatio = 100 / listOfChapters?.length;
    let totalCompleteCoursePercentage = 0;

    listOfChapters.length > 0 &&
      listOfChapters.forEach((chapter) => {
        if (chapter.isFinished) {
          totalCompleteCoursePercentage += chapterPercentageRatio;
        } else {
          chapter.files.length > 0 &&
            chapter.files.forEach((fileOfChapter) => {
              if ("duration" in fileOfChapter) {
                totalTragetDuration += fileOfChapter.duration;
              }
              if ("progress" in fileOfChapter) {
                const { durationCompleted } = {
                  ...fileOfChapter.progress,
                };
                tillNowCompletedDuration += durationCompleted;
              }
            });
        }
      });
    if (tillNowCompletedDuration !== 0 && totalTragetDuration !== 0) {
      let count = 0;
      listOfChapters &&
        listOfChapters.length > 0 &&
        listOfChapters.forEach((list) => list.isFinished == false && count++);
      let getPercentageofUnfinshedChapter =
        (tillNowCompletedDuration * count * 100) /
        (totalTragetDuration * listOfChapters?.length);

      totalCompleteCoursePercentage += getPercentageofUnfinshedChapter;
    }

    return totalCompleteCoursePercentage;
  };

  useEffect(() => {
    if (course) {
      const coursePercentage = chapterPercentageCalculation(course);
      setCourseProgress(coursePercentage);
    }
  }, [course]);

  useEffect(() => {
    if (courseprogress.toFixed(0) == 100) {
      axiosInstance
        .get(`course/gen/certificate?courseId=${course[0].courseID}`)
        .then((response) => {
          setResponse(response.data.message);
          setCertificateDetails(response.data.data.fileName);
        });
    }
  }, [courseprogress]);

  const showHandler = () => {
    setPrintCertificate(!printCertificate);
  };

  return (
    <>
      <div className="progressBarMain-container">
        <label className="courseProgress-label">
          {t("status.courseProgress")} <span>{courseprogress.toFixed(0)}%</span>
        </label>
        <ProgressBar barMinWidth={`${courseprogress.toFixed(2)}%`} />
        {certifcateDetails && (
          <Button
            title={"Print your Certificate"}
            className={"btn"}
            handleClick={showHandler}
          />
        )}
        {printCertificate && (
          <OverlayContainer>
            {certifcateDetails && (
              <ChapterDocument
                type={"pdf"}
                url={getS3URL(certifcateDetails)}
                closeHandler={showHandler}
                show={printCertificate}
              />
            )}
          </OverlayContainer>
        )}
      </div>
    </>
  );
};
export default CoursePercentage;
